import React from "react";
import "./ButtonQustion.scss";

export const answerEnum = {correct: "correct", wrong: "wrong"}
const ButtonQustion = (props) => {
  const type = props.answerIndex 
  return (
    <button disabled={props.disabled} onClick={props.onClick} className={`option-button ${props.answerIndex === answerEnum.correct ? "option-button-correct"  : 
      props.answerIndex === answerEnum.wrong? "option-button-wrong" : "option-button-normal"}`}>
    {props.children}
  </button>
  );
};

export default ButtonQustion;
